"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FEMALE = exports.MALE = void 0;
exports.MALE = 'M';
exports.FEMALE = 'F';
//# sourceMappingURL=genders.js.map